module.exports = __webpack_public_path__ + "static/img/home_productcard_tunnel_mobile.9e8eaba8.jpg";